/* Paintly Kits: the Shape option on catalogue product pages (pilot, 14 October 2026).
   Markup from snippets/paintly-shape-ai.liquid, looks in assets/paintly-shape-ai.css.

   - The tiles drive the picker's own shape buttons (kept, hidden), so the picker chooses and filters sizes
     exactly as it does on designs that already sell more than one shape. The tiles follow the picker back:
     tapping a square size in the size list selects the Square tile too.
   - Wide and square pictures come from paintly-shape-generator: GET /api/shape/status on load, then
     POST /api/shape and /api/shape/poll when the shopper chooses a shape that has no picture yet. A picture
     already approved for the design (status "ready") shows straight away.
   - The picture shown goes into the cart as properties[_AI Image URL], like AI kits, only while the chosen
     size has the picture's shape. Adding to the cart tells the service which picture was chosen (/pick).
   - No tries counter (Amjhed, 13 October). "Try again" (was "Try another" until 14 Oct, Amjhed) makes a new version; earlier versions stay
     selectable. Pictures made on this device are remembered for 30 days, so a reload never pays again, and the
     panel says so under the picture (Amjhed, 14 October: "this device" line now, AI Studio saving later).
   - The "customize the design" card under the buy buttons opens the AI page on the shape chosen here
     (&shape=wide or &shape=square on its link; Amjhed, 14 October).
   - Saved in the AI Studio (service 0.2.4, 14 October): the browser's AI Studio id (assets/paintly-owner.js)
     goes in the BODY of start and pick, never in a URL or a log. The panel says "Saved in your AI Studio"
     only after the Studio's own list (/api/shape/mine) has shown that picture; until then, or when the list
     cannot be read, it keeps the "on this device" line. A link from the AI Studio (?design= with no
     variant) opens on that picture's shape.
   - Anything that goes wrong leaves the page as it is today: the shopper can still buy that shape and the
     supplier fits the design to it, as with squares now.
   - After Codex's review (14 October): "Saved" belongs to the browser id it was checked for, and is checked
     again now and then; a pick is only remembered once the service has answered it, and is tried again
     otherwise; a picture only goes to the cart once it has loaded here, and a missing one says so.
   - After Codex's re-review (14 October): time alone never counts as a picture loading; a picture that did not
     load is kept and stays chosen (never forgotten on its own, never swapped for another), and the shopper can
     load it again, remove it, choose another or buy the fitted original after a second tap; a Studio check
     that had to wait runs once the wait is over; a pick counts only on {ok:true}.
   - Amjhed's decisions after the T1-T5 retest (14 October): while a picture is being made, Add to cart is not held:
     the first tap says so, and a second tap buys the original design fitted to this shape. A shape never made with
     AI here (previews off, the service down, the AI refused it, or never asked) buys with one tap, as today; the
     question is only for a shape that had pictures here and none of them can go to the cart. */
(function () {
  'use strict';
  if (window.__pkShapeAI) return;
  window.__pkShapeAI = 1;

  var SP = '<svg class="pkso-sp" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.1 5.6L20 9.7l-5.9 2.1L12 17.4l-2.1-5.6L4 9.7l5.9-2.1z"/><path d="M19 15l.9 2.3 2.3.9-2.3.9L19 21.4l-.9-2.3-2.3-.9 2.3-.9z"/></svg>';
  /* Names match the size list's own badges (Amjhed, 14 October): Portrait, Landscape, Square. */
  var LABEL = { Portrait: 'Portrait', Landscape: 'Landscape', Square: 'Square' };
  var AI = { Landscape: 'wide', Square: 'square' };
  var WORD = { wide: 'Landscape', square: 'Square' };
  var NOUN = { wide: 'landscape', square: 'square' };
  var RATIO = { wide: '4/3', square: '1/1' };
  var RATIO_N = { wide: 4 / 3, square: 1 };
  var PROP = 'properties[_AI Image URL]';
  var KEEP_MS = 30 * 24 * 3600 * 1000, MAX_VERSIONS = 4;
  var POLL_FIRST = 2500, POLL_EVERY = 3000, GIVE_UP_MS = 5 * 60 * 1000;
  /* A shopper's choice of a shape (a tile, or a size of that shape in the list) counts for this long, so the
     picker's answer to that tap can start the picture. Changes the page makes by itself never do. */
  var TAP_MS = 2500;
  /* Reasons a second attempt can help. A safety refusal is the same every time, a limit is a limit. */
  var RETRY = { error: 1, network: 1, timeout: 1, busy: 1, product: 1, image: 1, failed: 1, verify: 1 };
  /* a "Saved" line is read again from the Studio's list when it is older than this */
  var RECHECK_MS = 10 * 60 * 1000;
  /* a pick that did not get an answer is sent again, at most this many times per visit */
  var PICK_TRIES = 3;
  /* the fitted-original question (wording approved by Amjhed, 14 October) */
  var FITTED_ASK = 'Your kit will be made from the original design, fitted to this shape. <b>Tap again to buy it that way.</b>';
  var MAKING_ASK = 'Your picture is still being made. Tap Add to cart when it is ready. If you buy now, your kit will be made from the original design, fitted to this shape. <b>Tap again to buy it that way.</b>';

  function orientOf(s) {
    var m = String(s || '').match(/(\d+)\s*x\s*(\d+)/i);
    if (!m) return null;
    var w = +m[1], h = +m[2];
    return w === h ? 'Square' : (w > h ? 'Landscape' : 'Portrait');
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function lsGet(k) { try { var v = window.localStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  /* can this browser keep anything at all? Without it the "on this device" line would not be true */
  var CAN_KEEP = (function () { try { var k = 'pkso:probe'; window.localStorage.setItem(k, '1'); window.localStorage.removeItem(k); return true; } catch (e) { return false; } })();
  /* the AI Studio's browser id: a bearer secret, so only ever in a POST body to the Shape service */
  function owner() {
    try { var id = window.PaintlyOwner && window.PaintlyOwner.id(); return typeof id === 'string' && /^[a-z0-9]{16,64}$/.test(id) ? id : ''; } catch (e) { return ''; }
  }
  /* Which id a remembered fact belongs to. The id itself is a bearer secret and stays out of this file's
     storage; a short fingerprint of it is enough to tell "this browser's id" from "an id it used to have". */
  function fp(id) {
    if (!id) return '';
    var h1 = 0x811c9dc5, h2 = 0x2f2c1ab7;
    for (var i = 0; i < id.length; i++) {
      var c = id.charCodeAt(i);
      h1 = Math.imul(h1 ^ c, 0x01000193) >>> 0;
      h2 = Math.imul(h2 ^ c, 0x5bd1e995) >>> 0;
      h2 = (h2 ^ (h2 >>> 13)) >>> 0;
    }
    return ('0000000' + h1.toString(16)).slice(-8) + ('0000000' + h2.toString(16)).slice(-8);
  }
  function me() { return fp(owner()); }
  function tri(x) { return typeof x === 'string' ? (/^[0-9a-f]{16}$/.test(x) || x === '?' ? x : '') : (x ? '?' : ''); }
  /* The Studio's list allows 20 reads a minute per network, shared by every tab. After a 429 nobody here asks
     again until the wait is over; the AI Studio page reads and writes the same key. */
  var WAIT_KEY = 'pkso:mine:wait';
  function listWait() { try { var t = +window.localStorage.getItem(WAIT_KEY) || 0; return t > Date.now() ? t : 0; } catch (e) { return 0; } }
  function setListWait(h) {
    var secs = 60, n = parseInt(h, 10);
    if (h && String(n) === String(h).trim()) secs = n;
    else if (h) { var d = Date.parse(h); if (isFinite(d)) secs = Math.ceil((d - Date.now()) / 1000); }
    secs = Math.max(1, Math.min(600, secs || 60));
    try { window.localStorage.setItem(WAIT_KEY, String(Date.now() + secs * 1000)); } catch (e) {}
  }
  var STUDIO = '/pages/ai-studio';
  function timed(url, opts, ms) {
    var c = window.AbortController ? new AbortController() : null, t;
    if (c) { opts.signal = c.signal; t = setTimeout(function () { c.abort(); }, ms); }
    return window.fetch(url, opts).then(function (r) { clearTimeout(t); return r; }, function (e) { clearTimeout(t); throw e; });
  }

  /* Cloudflare's bot check, loaded only if the service asks for it ({status:"verify"}). The secret side is
     the store's existing AI Studio key on the worker. */
  var tsLoading = null;
  function turnstileToken(sitekey, box) {
    if (!sitekey || !box) return Promise.resolve('');
    if (!tsLoading) {
      tsLoading = new Promise(function (resolve, reject) {
        if (window.turnstile) { resolve(); return; }
        var s = document.createElement('script');
        s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        s.async = true;
        s.onload = function () { resolve(); };
        s.onerror = function () { tsLoading = null; reject(new Error('turnstile')); };
        document.head.appendChild(s);
      });
    }
    return tsLoading.then(function () {
      return new Promise(function (resolve) {
        var done = false, id = null;
        function finish(token) {
          if (done) return;
          done = true;
          setTimeout(function () { try { if (id !== null) window.turnstile.remove(id); } catch (e) {} box.innerHTML = ''; }, 0);
          resolve(token || '');
        }
        try {
          id = window.turnstile.render(box, {
            sitekey: sitekey, appearance: 'interaction-only', action: 'shape',
            callback: function (t) { finish(t); },
            'error-callback': function () { finish(''); },
            'expired-callback': function () { finish(''); },
            'timeout-callback': function () { finish(''); }
          });
        } catch (e) { finish(''); }
        setTimeout(function () { finish(''); }, 45000);
      });
    }).catch(function () { return ''; });
  }

  function init(root) {
    if (root.__pkso) return;
    root.__pkso = 1;
    var cfg;
    try { cfg = JSON.parse(root.querySelector('script[data-pkso-cfg]').textContent); } catch (e) { return; }
    var ui = root.closest('.pbnvp');
    if (!ui || !cfg || !cfg.api || !cfg.handle) return;
    var vs = ui.closest('variant-selects') || ui.parentNode;
    var section = root.closest('.shopify-section') || document;
    var API = cfg.api, HANDLE = cfg.handle, NATIVE = cfg.native;
    var tiles = [].slice.call(root.querySelectorAll('[data-pkso-shape]'));
    var panel = root.querySelector('.pkso-panel');
    var note = root.querySelector('.pkso-note');
    var hint = root.querySelector('.pkso-hint');
    var live = root.querySelector('.pkso-live');
    var sizeName = ui.getAttribute('data-o-size') || 'Size';

    var design = '', enabled = true, statusDone = false;
    var linkIntent = null, linkCanceled = false, linkApplied = false, linkApplying = false;
    var linkNotice = document.createElement('div');
    linkNotice.className = 'pkso-say'; linkNotice.setAttribute('role', 'status'); linkNotice.hidden = true;
    root.appendChild(linkNotice);
    var cur = cfg.initial || NATIVE;          /* the shape the page shows */
    var tapShape = null, tapAt = 0;          /* the shape the shopper last asked for, and when */
    var st = {};                             /* per made shape: versions, chosen one, state */
    tiles.forEach(function (t) {
      var a = t.getAttribute('data-pkso-ai');
      if (a) st[a] = { list: [], idx: -1, remembered: false, state: 'idle', reason: '', job: '', t0: 0, gen: 0, fresh: false, timer: 0, hold: false, ask: false, fit: false, wantLib: false, ownedKey: '' };
    });

    function valid(u) {
      return typeof u === 'string' && u.length < 400 && u.indexOf(API + '/images/') === 0 && /^[A-Za-z0-9_\-.\/:]+$/.test(u) && u.indexOf('..') < 0;
    }
    function say(msg) { if (live) live.textContent = msg; }
    function call(path, body, ms, keepalive) {
      var opts = { method: body ? 'POST' : 'GET', credentials: 'omit', mode: 'cors' };
      if (body) { opts.headers = { 'Content-Type': 'application/json' }; opts.body = JSON.stringify(body); }
      if (keepalive) opts.keepalive = true;
      return timed(API + path, opts, ms || 15000).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          j = (j && typeof j === 'object') ? j : {};
          j._http = r.status;
          try { j._retry = r.headers.get('Retry-After') || ''; } catch (e) { j._retry = ''; }
          return j;
        });
      });
    }

    /* ---- remembering pictures on this device ---- */
    function key() { return 'pkso:v1:' + (design || HANDLE); }
    /* Per version: u picture, j job, t made, and three facts that each name the browser id (by fingerprint) they
       were true for: pa the pick the service answered ("-" when it was sent without an id), o the id that owns
       it, sv the id whose Studio list showed it, at sa. pf: the service said this job cannot be picked. The old
       p flag (set before the pick was answered) is not read any more, so a pick it stranded is sent again. */
    function rec(v) { return { u: v.u, j: v.j || '', pa: v.pa || '', pf: v.pf ? 1 : 0, t: v.t || 0, o: v.o || '', sv: v.sv || '', sa: v.sa || 0 }; }
    function save() {
      var out = { t: Date.now() };
      Object.keys(st).forEach(function (a) {
        var s = st[a], sel = s.idx >= 0 ? s.list[s.idx] : null;
        /* Do not turn an untouched shape into an explicit "none chosen" when another shape is saved. */
        if (!s.remembered && !s.list.length) return;
        var keep = s.list.filter(function (v) { return !v.lib; });
        /* i: the chosen version among those kept here. -1: none chosen, and it stays that way after a reload, so
           no other version is put in its place (Codex re-review R2). -2: the design's library picture, which is
           not kept here and is chosen again when the service lists it. */
        out[a] = { i: !sel ? -1 : (sel.lib ? -2 : keep.indexOf(sel)), l: keep.map(rec) };
      });
      lsSet(key(), out);
    }
    function restore() {
      var got = lsGet(key());
      if (!got || !got.t || Date.now() - got.t > KEEP_MS) return;
      Object.keys(st).forEach(function (a) {
        var s = st[a], g = got[a];
        if (!g || !Array.isArray(g.l)) return;
        s.remembered = true;
        var i = typeof g.i === 'number' ? g.i : 0;
        var selectedURL = i >= 0 && g.l[i] && g.l[i].u;
        s.wantLib = i === -2;
        g.l.forEach(function (v) {
          if (!v || !valid(v.u) || find(s, v.u)) return;
          s.list.push({ u: v.u, j: typeof v.j === 'string' ? v.j : '', pa: /^([0-9a-f]{16}|-)$/.test(v.pa || '') ? v.pa : '', pf: !!v.pf,
                        t: +v.t || 0, o: tri(v.o), sv: tri(v.sv), sa: +v.sa || 0 });
        });
        /* Resolve by picture before trimming. Filtering or dropping an entry must not move the choice. */
        s.idx = selectedURL ? s.list.indexOf(find(s, selectedURL)) : -1;
        trim(s);
        s.state = 'ready';
      });
    }
    /* "Saved in your AI Studio" only for the id this browser has now */
    function saved(v) { var k = me(); return !!(v && k && v.sv === k); }
    function find(s, u) { for (var i = 0; i < s.list.length; i++) if (s.list[i].u === u) return s.list[i]; return null; }
    function trim(s) {
      while (s.list.length > MAX_VERSIONS) {
        /* The library entry is inserted first; evict the oldest local entry, not the library we just offered. */
        var drop = 0;
        while (drop < s.list.length && s.list[drop].lib) drop++;
        if (drop === s.list.length) drop = 0;
        s.list.splice(drop, 1);
        if (s.idx === drop) s.idx = -1;
        else if (s.idx > drop) s.idx--;
      }
    }

    /* ---- the picker ---- */
    function hiddenBtn(o) { return ui.querySelector('.pbnvp-shapes [data-shape="' + o + '"]'); }
    function pickedShape() {
      var b = ui.querySelector('.pbnvp-shapes [data-shape][aria-pressed="true"]');
      return b ? b.getAttribute('data-shape') : null;
    }
    function sizeShape() {
      var sel = vs.querySelector('select[name="options[' + sizeName + ']"]');
      return sel ? orientOf(sel.value) : null;
    }
    function form() {
      return section.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('product-form[data-main="true"] form');
    }

    /* the version on show for the chosen shape, while the chosen size really is this shape */
    function selected() {
      var a = AI[cur], s = a && st[a];
      if (!s || !s.list.length || s.idx < 0) return null;
      if (pickedShape() !== cur || sizeShape() !== cur) return null;
      return s.list[s.idx] || null;
    }
    /* the version the cart gets: the one on show, once its picture has loaded here */
    function chosen() { var v = selected(); return v && v.av === 'ok' ? v : null; }

    /* A picture goes to the cart only once it has loaded here (Codex review F4; re-review R1 and R3).
       loading: asked for. ok: it loaded. slow: no answer after 20 seconds, which is not counted as loaded, and an
       answer that comes later still counts either way. failed: it did not load. A missing file and a dropped
       connection look the same to an image, so a picture that failed is never forgotten on its own: it stays
       remembered and chosen, cannot go to the cart, and the shopper can load it again or remove it. Only the
       newest attempt's error or timeout counts; a load from any attempt does. */
    function check(a, v, again) {
      if (v.av && !again) return;
      var n = v.ck = (v.ck || 0) + 1, im = new Image();
      v.av = 'loading';
      im.onload = function () {
        if (v.av === 'ok') return;
        if (im.naturalWidth > 0) v.av = 'ok';
        else if (n === v.ck) v.av = 'failed';
        else return;
        settle(a);
      };
      im.onerror = function () { if (n === v.ck && v.av !== 'ok') { v.av = 'failed'; settle(a); } };
      setTimeout(function () { if (n === v.ck && v.av === 'loading') { v.av = 'slow'; settle(a); } }, 20000);
      im.src = v.u;
    }
    /* what the shopper agreed to (buy the fitted original) belongs to the situation they saw: it ends with it */
    function settle(a) { var s = st[a]; if (s) { s.hold = false; s.ask = false; s.fit = false; } panelKey = ''; render(); }
    function setProp() {
      var f = form();
      if (!f) return;
      var v = linkWaiting() ? null : chosen(), inp = f.querySelector('input[data-pkso-prop]');
      if (!v) { if (inp) inp.parentNode.removeChild(inp); return; }
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = PROP;
        inp.setAttribute('data-pkso-prop', '');
        f.appendChild(inp);
      }
      if (inp.value !== v.u) inp.value = v.u;
    }

    /* ---- the main gallery ---- */
    function mainSlide() {
      var g = section.querySelector('media-gallery') || section;
      var li = cfg.media ? g.querySelector('.product__media-item[data-media-id$="-' + cfg.media + '"]') : null;
      return li || g.querySelector('.product__media-item');
    }
    function gallery(mode, a, url) {
      var li = mainSlide();
      if (!li) return;
      var box = li.querySelector('.product-media-container');
      var img = li.querySelector('.product__media img');
      if (!box || !img) return;
      var o = box.__pkso;
      if (!o || o.img !== img) {
        o = box.__pkso = {
          img: img, src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), sizes: img.getAttribute('sizes'),
          ratio: box.style.getPropertyValue('--ratio'), pr: box.style.getPropertyValue('--preview-ratio')
        };
      }
      var chip = box.querySelector('.pkso-gchip');
      function put(text) {
        if (!chip) { chip = document.createElement('span'); chip.className = 'pkso-gchip'; box.appendChild(chip); }
        /* compared by a note, not by innerHTML: the browser re-serializes the SVG, and a rewrite here would
           wake the gallery observer below on every pass */
        if (chip.getAttribute('data-t') !== text) { chip.setAttribute('data-t', text); chip.innerHTML = SP + '<span>' + esc(text) + '</span>'; }
      }
      function original() {
        if (img.getAttribute('data-pkso-src')) {
          if (o.srcset) img.setAttribute('srcset', o.srcset);
          if (o.sizes) img.setAttribute('sizes', o.sizes);
          img.setAttribute('src', o.src);
          img.removeAttribute('data-pkso-src');
          box.style.setProperty('--ratio', o.ratio);
          box.style.setProperty('--preview-ratio', o.pr);
        }
        box.classList.remove('pkso-swapped');
      }
      if (mode === 'show' || mode === 'show-making') {
        if (img.getAttribute('data-pkso-src') !== url) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.setAttribute('src', url);
          img.setAttribute('data-pkso-src', url);
        }
        box.style.setProperty('--ratio', String(RATIO_N[a]));
        box.style.setProperty('--preview-ratio', String(RATIO_N[a]));
        box.classList.add('pkso-swapped');
        box.classList.toggle('pkso-gmaking', mode === 'show-making');
        put(mode === 'show-making' ? 'Making another ' + NOUN[a] + ' version' : WORD[a] + ' version');
      } else if (mode === 'making') {
        original();
        box.classList.add('pkso-gmaking');
        put('Making your ' + NOUN[a] + ' version');
      } else {
        original();
        box.classList.remove('pkso-gmaking');
        if (chip) chip.parentNode.removeChild(chip);
      }
    }

    /* ---- drawing ---- */
    var panelKey = '';
    function tileArt(a, s) {
      if (s.list.length && s.idx >= 0 && s.list[s.idx]) {
        var v = s.list[s.idx];
        if (v.av === 'failed') return { k: 'off', html: '<span class="pkso-mk pkso-mk--' + a + ' is-plain"><img src="' + esc(cfg.tall) + '" alt=""></span>' };
        return { k: 'img:' + v.u, html: '<img class="pkso-th pkso-th--' + a + '" src="' + esc(v.u) + '" alt="" decoding="async">' };
      }
      if (s.list.length && s.state !== 'making') return { k: 'pick', html: '<span class="pkso-mk pkso-mk--' + a + '">' + SP + '<span>Choose</span></span>' };
      if (s.state === 'making') return { k: 'making', html: '<span class="pkso-mk pkso-mk--' + a + ' is-busy">' + SP + '<span>Making</span></span>' };
      /* no picture this time: the design as shown, sitting in the shape, which is roughly what the supplier fits */
      if (!enabled || s.state === 'fallback') return { k: 'plain', html: '<span class="pkso-mk pkso-mk--' + a + ' is-plain"><img src="' + esc(cfg.tall) + '" alt=""></span>' };
      return { k: 'make', html: '<span class="pkso-mk pkso-mk--' + a + '">' + SP + '<span>Make it</span></span>' };
    }
    function fallbackWords(reason) {
      var first = reason === 'off' ? 'Previews are paused right now.'
        : reason === 'limit' ? 'That is a lot of previews for today.'
        : reason === 'blocked' ? 'Our AI could not make this one.'
        : 'We could not make a preview right now.';
      return first + ' You can still buy this shape, and we will fit the design to it before printing.';
    }
    function versions(a, s, all) {
      if (s.list.length < (all ? 1 : 2)) return '';
      var h = '<span class="pkso-vers" role="group" aria-label="Your versions">';
      s.list.forEach(function (v, i) {
        var off = v.av === 'failed';
        h += '<button type="button" data-pkso-act="ver" data-i="' + i + '" aria-pressed="' + (i === s.idx) + '" aria-label="Version ' + (i + 1) + (off ? ', did not load' : '') + '">' +
          (off ? '<img src="' + esc(cfg.tall) + '" alt="" style="opacity:.4">' : '<img src="' + esc(v.u) + '" alt="" decoding="async">') + '</button>';
      });
      return h + '</span>';
    }
    function drawPanel() {
      var a = AI[cur], s = a && st[a];
      if (cur === NATIVE || !s) {
        if (!panel.hidden) { panel.hidden = true; panel.innerHTML = ''; panelKey = ''; }
        return;
      }
      var cv = s.idx >= 0 ? s.list[s.idx] : null;
      var k = [a, s.state, s.idx, s.list.length, s.reason, enabled, s.fresh, s.job, cv ? cv.u : '', cv ? cv.av : '', saved(cv) ? 1 : 0, s.hold ? 1 : 0, s.ask ? 1 : 0,
               s.list.map(function (x) { return x.av === 'failed' ? 1 : 0; }).join('')].join('|');
      if (k === panelKey) return;
      panelKey = k;
      var word = NOUN[a], h = '';
      if (s.state === 'making') {
        var ago = Math.max(0, (Date.now() - s.t0) / 1000).toFixed(1);
        h = '<div class="pkso-media"><div class="pkso-paint" style="aspect-ratio:' + RATIO[a] + '"><span class="bg" style="background-image:url(\'' + esc(cfg.tall) + '\')"></span><img src="' + esc(cfg.tall) + '" alt=""><span class="sh"></span>' +
          '<span class="pkso-msg"><b>' + SP + 'Making your ' + word + ' version with AI</b><small>Your new version will appear as soon as it’s ready.</small><span class="pkso-bar"><i style="animation-delay:-' + ago + 's"></i></span></span></div></div>' +
          '<div class="pkso-desk"><b>' + SP + 'Making your ' + word + ' version with AI</b><small>Your new version will appear as soon as it’s ready.</small><span class="pkso-bar"><i style="animation-delay:-' + ago + 's"></i></span></div>' +
          (s.list.length ? '<div class="pkso-row"><small>Your earlier versions stay here.</small>' + versions(a, s) + '</div>' : '');
      } else if (s.list.length && (!cv || cv.av === 'slow' || cv.av === 'failed')) {
        /* No picture can go to the cart: none is chosen, or the chosen one has not loaded. Nothing is chosen in its
           place; the shopper loads it again, removes it, chooses, makes a new one, or buys the fitted original. */
        var others = s.list.length > (cv ? 1 : 0);
        var lead = !cv ? 'Choose one of your ' + word + ' versions below, or tap Try again for a new one.'
          : (cv.av === 'slow' ? 'This ' + word + ' picture is taking a long time to load.' : 'This ' + word + ' picture did not load. It may be the connection.') +
            ' You can load it again, ' + (others ? 'choose another version below, ' : '') + 'or tap Try again for a new one.';
        h = (s.reason ? '<p class="pkso-say">We could not make another version right now.</p>' : '') +
          '<p class="pkso-say">' + lead + ' If you buy now, your kit will be made from the original design, fitted to this shape.</p>' +
          (cv ? '<div class="pkso-row"><button type="button" class="pkso-lk" data-pkso-act="reload">Load it again</button>' +
                (cv.av === 'failed' ? '<button type="button" class="pkso-lk" data-pkso-act="remove">Remove it</button>' : '') + '</div>' : '') +
          '<div class="pkso-row"><button type="button" class="pkso-lk" data-pkso-act="another">Try again</button>' + versions(a, s, true) + '</div>';
      } else if (s.list.length) {
        var v = cv;
        var chip = s.fresh && s.idx === s.list.length - 1 ? 'Just made for you' : WORD[a] + ', made with AI';
        h = '<div class="pkso-media"><div class="pkso-big" style="aspect-ratio:' + RATIO[a] + '"><img src="' + esc(v.u) + '" alt="' + esc(WORD[a] + ' version of this design, made with AI') + '" decoding="async"><span class="pkso-chip">' + SP + chip + '</span></div></div>' +
          '<div class="pkso-desk"><b>' + SP + chip + '</b><small>Shown in the big picture.</small></div>' +
          '<div class="pkso-row"><button type="button" class="pkso-lk" data-pkso-act="another">Try again</button>' + versions(a, s) + '</div>' +
          (s.reason ? '<p class="pkso-say">We could not make another version right now.</p>' : '') +
          (s.hold ? '<p class="pkso-say">Your picture is still loading. Tap Add to cart again in a moment.</p>' : '') +
          (saved(v) ? '<p class="pkso-keep">' + SP + 'Saved in your <a href="' + STUDIO + '">AI Studio</a>.</p>'
                : (CAN_KEEP ? '<p class="pkso-keep">We keep your ' + word + ' version on this device for 30 days.</p>' : ''));
      } else if (s.state === 'fallback' || !enabled) {
        var r = enabled ? s.reason : 'off';
        h = '<p class="pkso-say">' + esc(fallbackWords(r)) + '</p>' +
          (enabled && RETRY[r] ? '<div class="pkso-row"><button type="button" class="pkso-lk" data-pkso-act="make">Try again</button></div>' : '');
      } else {
        h = '<p class="pkso-say">See this design as a <b>' + word + '</b> picture before you buy.</p>' +
          '<div class="pkso-row"><button type="button" class="pkso-btn" data-pkso-act="make">' + SP + 'Make my ' + word + ' version</button></div>';
      }
      /* The same question is visible even when the shopper removed their last version. While a picture is being made
         it also says that waiting gets the picture (Amjhed, 14 October). */
      if (s.ask) h += '<p class="pkso-say">' + (s.state === 'making' ? MAKING_ASK : FITTED_ASK) + '</p>';
      h += '<div class="pkso-ts"></div>';
      panel.innerHTML = h;
      panel.hidden = false;
    }
    /* the "customize the design" card: open the AI page on the shape chosen here */
    function remixLink() {
      var l = section.querySelector('a.pk-remix') || document.querySelector('a.pk-remix');
      if (!l) return;
      if (!l.hasAttribute('data-pkso-href')) {
        if (!/[?&]remix=/.test(l.getAttribute('href') || '')) return;
        l.setAttribute('data-pkso-href', l.getAttribute('href'));
      }
      var base = l.getAttribute('data-pkso-href'), a = AI[cur];
      var want = a ? base + (base.indexOf('?') < 0 ? '?' : '&') + 'shape=' + a : base;
      if (l.getAttribute('href') !== want) l.setAttribute('href', want);
    }
    function render() {
      showLinkState();
      tiles.forEach(function (t) {
        var o = t.getAttribute('data-pkso-shape'), on = o === cur;
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        t.classList.toggle('on', on);
        var a = t.getAttribute('data-pkso-ai');
        if (!a) return;
        var fr = t.querySelector('.pkso-fr'), art = tileArt(a, st[a]), sm = t.querySelector('small');
        if (fr && fr.getAttribute('data-k') !== art.k) { fr.setAttribute('data-k', art.k); fr.innerHTML = art.html; }
        /* "Make with AI" until this shape has a picture, "Made with AI" once it does (Amjhed, 14 October) */
        var sub = art.k === 'plain' ? 'Fitted for you' : art.k === 'off' ? 'Did not load' : art.k === 'pick' ? 'Choose a version'
          : (art.k.indexOf('img:') === 0 ? 'Made with AI' : 'Make with AI');
        if (sm && sm.textContent !== sub) sm.textContent = sub;
      });
      if (hint) hint.textContent = cur === NATIVE ? 'Same design, ' + tiles.length + ' ways' : LABEL[cur] + ' sizes below';
      if (note) note.hidden = cur !== NATIVE;
      drawPanel();
      remixLink();
      var a = AI[cur], s = a && st[a], v = s && s.idx >= 0 ? s.list[s.idx] : null;
      if (v && v.av !== 'failed') gallery(s.state === 'making' ? 'show-making' : 'show', a, v.u);
      else if (s && s.state === 'making') gallery('making', a);
      else gallery('off');
      setProp();
      /* the picture each tile shows is loading anyway, so it is checked now; the other versions once their shape is open */
      Object.keys(st).forEach(function (b) {
        var t = st[b];
        if (b === a) t.list.slice().forEach(function (x) { check(b, x); });
        else if (t.idx >= 0 && t.list[t.idx]) check(b, t.list[t.idx]);
      });
    }

    /* ---- following the picker ---- */
    var fitSelection = null;
    function checkFitSelection() {
      var values = [pickedShape()];
      [].forEach.call(vs.querySelectorAll('select'), function (el) { values.push(el.name, el.value); });
      var f = form(), id = f && f.querySelector('[name="id"]');
      values.push(id ? id.value : '');
      var next = JSON.stringify(values);
      if (fitSelection !== null && fitSelection !== next) {
        Object.keys(st).forEach(function (a) { st[a].fit = false; st[a].ask = false; st[a].hold = false; });
        panelKey = '';
      }
      fitSelection = next;
    }
    function follow() {
      checkFitSelection();
      var previous = cur;
      var p = pickedShape();
      if (p) cur = p;
      else if (!tapShape) cur = cfg.initial || NATIVE;
      if (previous !== cur) {
        Object.keys(st).forEach(function (b) { st[b].fit = false; st[b].ask = false; st[b].hold = false; });
      }
      var a = AI[cur], s = a && st[a];
      var asked = tapShape === cur && Date.now() - tapAt < TAP_MS;
      if (asked) tapShape = null;
      if (asked && s && statusDone && enabled && !s.list.length && s.state === 'idle') { make(a, false); return; }
      render();
    }
    function choose(o) {
      if (linkWaiting() && o === WORD[linkIntent.shape]) { showLinkState(); return; }
      cancelLink();
      tapShape = o;
      tapAt = Date.now();
      var b = hiddenBtn(o);
      if (b) b.click();
      if (!b) cur = o;
      follow();
    }

    /* ---- making a picture ---- */
    function make(a, another) {
      var s = st[a];
      if (!s || s.state === 'making') return;
      clearTimeout(s.timer);
      s.fit = false; s.ask = false; s.hold = false;
      if (!enabled) { s.state = 'fallback'; s.reason = 'off'; render(); return; }
      var gen = ++s.gen;
      s.state = 'making'; s.reason = ''; s.job = ''; s.t0 = Date.now(); s.fresh = false;
      say('Making your ' + NOUN[a] + ' version with AI.');
      render();
      s.ownedKey = me();
      start(a, another, '').then(function (r) { if (gen === s.gen) answer(a, r, gen); });
    }
    function tsBox() { return panel.querySelector('.pkso-ts'); }
    function start(a, another, token) {
      var body = { handle: HANDLE, shape: a, another: !!another }, oid = owner();
      if (token) body.turnstileToken = token;
      if (oid) body.ownerId = oid;
      return call('/api/shape', body, 30000).then(function (r) {
        if (r.status === 'verify' && !token) {
          return turnstileToken(cfg.sitekey, tsBox()).then(function (t) {
            return t ? start(a, another, t) : { status: 'fallback', reason: 'verify' };
          });
        }
        if (r._http === 429 && !r.reason) r.reason = 'limit';
        return r;
      }, function () { return { status: 'fallback', reason: 'network' }; });
    }
    function answer(a, r, gen) {
      var s = st[a];
      if (r.status === 'ready' && valid(r.imageUrl)) { got(a, r.imageUrl, r.jobId || '', r.source !== 'library' && r.source !== 'original', gen); return; }
      if (r.status === 'making' && typeof r.jobId === 'string' && r.jobId) { s.job = r.jobId; poll(a, gen, POLL_FIRST); return; }
      fail(a, r.status === 'off' ? 'off' : (r.reason || (r.status === 'unavailable' ? 'unavailable' : 'error')), gen);
    }
    function poll(a, gen, wait) {
      var s = st[a];
      clearTimeout(s.timer);
      s.timer = setTimeout(function () {
        if (gen !== s.gen) return;
        if (Date.now() - s.t0 > GIVE_UP_MS) { fail(a, 'timeout', gen); return; }
        call('/api/shape/poll', { jobId: s.job }, 15000).then(function (r) {
          if (gen !== s.gen) return;
          if (r.status === 'making') { poll(a, gen, POLL_EVERY); return; }
          answer(a, r, gen);
        }, function () { if (gen === s.gen) poll(a, gen, POLL_EVERY * 2); });
      }, wait);
    }
    function got(a, url, job, fresh, gen) {
      var s = st[a], im = new Image();
      im.onload = function () {
        if (gen !== s.gen) return;
        var have = find(s, url);
        if (!have) { s.list.push({ u: url, j: job, pa: '', t: Date.now(), lib: !fresh && !job, o: fresh && job ? s.ownedKey : '', sv: '', sa: 0, av: 'ok' }); trim(s); }
        else have.av = 'ok';
        s.idx = have ? s.list.indexOf(have) : s.list.length - 1;
        s.state = 'ready'; s.reason = ''; s.job = ''; s.fresh = fresh; s.ask = false; s.fit = false; s.hold = false;
        save();
        confirmSaved();
        say('Your ' + NOUN[a] + ' version is ready.');
        render();
      };
      im.onerror = function () { if (gen === s.gen) fail(a, 'image', gen); };
      im.src = url;
    }
    function fail(a, reason, gen) {
      var s = st[a];
      if (gen !== undefined && gen !== s.gen) return;
      s.state = s.list.length ? 'ready' : 'fallback';
      s.fit = false; s.ask = false; s.hold = false;
      s.reason = reason;
      s.job = '';
      say(s.list.length ? 'We could not make another version right now.' : fallbackWords(reason));
      render();
    }

    /* ---- the shopper ---- */
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pkso-shape]');
      if (t && root.contains(t)) { choose(t.getAttribute('data-pkso-shape')); return; }
      var b = e.target.closest('[data-pkso-act]');
      if (!b || !root.contains(b)) return;
      var a = AI[cur], s = a && st[a];
      if (!s) return;
      var act = b.getAttribute('data-pkso-act');
      if (act === 'make') make(a, false);
      else if (act === 'another') make(a, true);
      else if (act === 'ver') {
        s.idx = Math.max(0, Math.min(s.list.length - 1, +b.getAttribute('data-i') || 0));
        var vv = s.list[s.idx];
        s.fresh = false; s.ask = false; s.fit = false;
        if (vv && (vv.av === 'failed' || vv.av === 'slow')) check(a, vv, true);
        save(); render();
      }
      /* the chosen picture, asked for again */
      else if (act === 'reload') { var cr = s.idx >= 0 ? s.list[s.idx] : null; if (cr) { check(a, cr, true); settle(a); } }
      /* the shopper's own choice to forget a picture that did not load; nothing else is chosen in its place */
      else if (act === 'remove') {
        var cx = s.idx >= 0 ? s.list[s.idx] : null;
        if (!cx) return;
        s.list.splice(s.idx, 1);
        s.idx = -1; s.remembered = true;
        if (!s.list.length) s.state = 'ready';
        s.ask = false; s.fit = false;
        save(); say('Removed.'); render();
      }
    });
    /* a size tapped in the list is a choice of its shape */
    ui.addEventListener('click', function (e) {
      var r = e.target.closest('[data-size]');
      if (r && !root.contains(r)) { tapShape = orientOf(r.getAttribute('data-size')); tapAt = Date.now(); }
    }, true);
    var shapesRow = ui.querySelector('.pbnvp-shapes');
    if (shapesRow && window.MutationObserver) {
      new MutationObserver(function () { follow(); }).observe(shapesRow, { subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
    }
    /* Capture each selection change, including A -> B -> A before a deferred follow runs. */
    vs.addEventListener('change', function () { checkFitSelection(); setTimeout(follow, 0); }, true);
    section.addEventListener('change', function (e) {
      var f = form();
      if (e.target && e.target.name === 'id' && f && f.contains(e.target)) {
        checkFitSelection(); setTimeout(follow, 0);
      }
    }, true);
    /* The theme can redraw the gallery when the variant changes. Put the picture back if it does. */
    var galleryEl = section.querySelector('media-gallery');
    if (galleryEl && window.MutationObserver) {
      var gt = 0;
      new MutationObserver(function () { clearTimeout(gt); gt = setTimeout(render, 60); }).observe(galleryEl, { childList: true, subtree: true });
    }
    function onAdd(e) {
      var f = form();
      if (!f) return;
      var t = e.target, isAdd = false;
      if (e.type === 'submit') isAdd = t === f;
      else {
        var btn = t.closest && t.closest('button, [role="button"], shopify-buy-it-now-button, .shopify-payment-button');
        isAdd = !!btn && ((f.contains(btn) && (btn.name === 'add' || btn.type === 'submit' || !!btn.closest('.shopify-payment-button'))) || /^SectionAtcBtn-/.test(btn.id || ''));
      }
      if (!isAdd) return;
      if (linkWaiting()) { stop(e); showLinkState(); return; }
      checkFitSelection();
      var a = AI[cur], sh = a && st[a];
      if (sh && pickedShape() === cur && sizeShape() === cur) {
        var sel = sh.idx >= 0 ? sh.list[sh.idx] : null;
        if (sh.state !== 'making' && sel && (!sel.av || sel.av === 'loading')) {
          /* Outside generation, wait for the chosen picture. While making, N1 instead offers the fitted original. */
          stop(e);
          check(a, sel);
          sh.hold = true;
          say('Your picture is still loading. Tap Add to cart again in a moment.');
          panelKey = ''; render();
          return;
        }
        /* No picture can go to the cart. The first tap asks and the second buys the original design fitted to this
           shape (Codex re-review R1, R2) when this shape had pictures here (versions, or the shopper removed them) or
           one is being made; agreeing during a generation holds only for that generation (Codex T2). A shape never
           made with AI here buys with one tap, as today (Amjhed, 14 October). */
        var had = sh.state === 'making' || sh.list.length > 0 || sh.remembered;
        if (had && (!sel || sel.av !== 'ok')) {
          var size = vs.querySelector('select[name="options[' + sizeName + ']"]');
          var variant = f.querySelector('[name="id"]');
          var agreement = [a, sh.gen, sh.state, sel ? sel.u : '', sel ? sel.av : '', sel ? sel.ck : '',
                           size ? size.value : '', variant ? variant.value : ''].join('|');
          if (sh.fit !== agreement) {
            stop(e);
            sh.fit = agreement; sh.ask = true;
            say((sh.state === 'making' ? MAKING_ASK : FITTED_ASK).replace(/<\/?b>/g, ''));
            panelKey = ''; render();
            return;
          }
        }
      }
      setProp();
      var v = chosen();
      if (v) pick(v);
      confirmSaved();          /* a check left waiting by a cooldown gets its turn now, if it is due (R4) */
    }
    function stop(e) { e.preventDefault(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
    /* The pick says which picture was bought, and with the id it gives an unowned picture to this browser. It is
       remembered only once the service has answered it (Codex review F3). One at a time per picture, sent again
       after a failure (on the next tap, or by itself 5 seconds later) up to PICK_TRIES times a visit; the service
       treats a repeat as the same pick. A pick answered before this browser had an id is sent once more with it. */
    function pick(v) {
      var oid = owner(), k = fp(oid);
      if (!v.j || v.pf || v.inflight || (v.tries || 0) >= PICK_TRIES) return;
      if (v.pa && !(v.pa === '-' && k)) return;
      v.inflight = true;
      v.tries = (v.tries || 0) + 1;
      clearTimeout(v.rt);
      var pb = { jobId: v.j };
      if (oid) pb.ownerId = oid;
      call('/api/shape/pick', pb, 8000, true).then(function (r) {
        v.inflight = false;
        if (r._http === 200 && r.ok === true) {
          /* A list read begun before this acknowledgment cannot invalidate its follow-up check. */
          v.claimRevision = (v.claimRevision || 0) + 1;
          v.pa = k || '-';
          if (k && v.o !== k) v.o = k;     /* asked for this id; the Studio's list says whether it took */
          save();
          confirmSaved();
          return;
        }
        if (r._http === 400 || r._http === 404) { v.pf = true; save(); return; }
        again(v);
      }, function () { v.inflight = false; again(v); });
    }
    function again(v) {
      if ((v.tries || 0) >= PICK_TRIES) return;
      clearTimeout(v.rt);
      v.rt = setTimeout(function () { pick(v); }, 5000);
    }
    document.addEventListener('click', onAdd, true);
    document.addEventListener('submit', onAdd, true);

    /* ---- saved in the AI Studio ----
       One read of the Studio's own list, only when a picture might be there and is not yet known to be:
       after a picture made with the id, after a pick that sent the id, or a picture opened from a link.
       A refused or failed read (429, 503, network) changes nothing: the "on this device" line stays. */
    var linkCheck = false, listing = false, listedAt = 0, pendT = 0, pendAfter = false, listRetries = -1, pends = 0;
    /* What needs the list (Codex review F1): a picture this id may own and is not known to be in its Studio, a
       "Saved" older than RECHECK_MS, anything remembered from before ids were fingerprinted, or a picture
       opened from a link. A "Saved" for another id is simply not shown; it needs no read. */
    function needs(v, k, now) {
      if (v.lib) return false;
      if (v.sv === k) return now - (v.sa || 0) > RECHECK_MS;
      return v.o === k || v.o === '?' || v.sv === '?' || linkCheck;
    }
    /* A check that has to wait (a read already on its way, the 4 second gap, or a 429 wait set by any tab) is kept
       as one pending check: it runs when the read on its way ends, or once the wait is over, a little spread out
       so open tabs do not all ask at the same moment. After a 429 this page asks again at most twice a visit, so a
       list that keeps saying "too many" is not asked again and again, and a visit sets at most 10 such timers
       (Codex re-review R4). Who is asking, and whether anything still needs asking, is worked out when it runs. */
    function confirmSaved() {
      var oid = owner(), k = fp(oid), now = Date.now();
      if (!oid || listRetries === 0) return;
      var open = [];
      Object.keys(st).forEach(function (a) { st[a].list.forEach(function (v) {
        if (needs(v, k, now)) open.push({ version: v, revision: v.claimRevision || 0 });
      }); });
      if (!open.length) return;
      if (listing) { pendAfter = true; return; }
      var until = Math.max(listedAt + 4000, listWait());
      if (until > now) {
        if (!pendT && pends < 10) {
          pends++;
          pendT = setTimeout(function () { pendT = 0; confirmSaved(); }, until - now + 250 + Math.floor(Math.random() * 1500));
        }
        return;
      }
      clearTimeout(pendT); pendT = 0;
      /* Once refused, every dispatch shares the two remaining reads, regardless of its caller or outcome. */
      if (listRetries > 0) listRetries--;
      listing = true; listedAt = now;
      call('/api/shape/mine', { ownerId: oid }, 12000).then(function (r) {
        if (r._http === 429) {
          setListWait(r._retry);
          if (listRetries < 0) listRetries = 2;
          return listRetries > 0 ? 'again' : '';
        }
        if (r._http !== 200 || !r.pictures || !r.pictures.forEach) return;
        /* the id changed while the list was on its way (another tab): this answer is about the old one */
        if (me() !== k) { listedAt = 0; return 'again'; }
        var got = {};
        r.pictures.forEach(function (p) { if (p && typeof p.imageUrl === 'string') got[p.imageUrl] = 1; });
        open.forEach(function (entry) {
          var v = entry.version;
          if ((v.claimRevision || 0) !== entry.revision) { pendAfter = true; return; }
          if (got[v.u]) { v.sv = k; v.o = k; v.sa = Date.now(); }
          else {
            if (v.sv === k || v.sv === '?') { v.sv = ''; v.sa = 0; }
            if (v.o === k || v.o === '?') v.o = '';
          }
        });
        linkCheck = false;
        save();
        render();
      }, function () {}).then(function (x) {
        listing = false;
        if (x === 'again' || pendAfter) { pendAfter = false; confirmSaved(); }
      });
    }
    /* another tab changed the browser id: what this page says follows straight away */
    window.addEventListener('storage', function (e) {
      if (e.key === null || e.key === ((window.PaintlyOwner && window.PaintlyOwner.key) || 'ply_owner_id')) { panelKey = ''; render(); confirmSaved(); }
    });

    /* A cart line's "change" link opens this page with its picture (?design=...): show that picture. */
    function readLink() {
      var m = /[?&]design=([^&#]*)/.exec(location.search), u;
      if (!m) return null;
      try { u = decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return null; }
      var sm = valid(u) && u.match(/\/images\/(?:shapes|library)\/[^\/]+\/(wide|square)\//);
      return sm && st[sm[1]] ? { url: u, shape: sm[1], explicit: /[?&]variant=/.test(location.search) } : null;
    }
    function linkWaiting() { return !!linkIntent && !linkCanceled && !linkApplied; }
    function cancelLink() {
      if (linkApplying || !linkWaiting()) return;
      linkCanceled = true; showLinkState();
    }
    function showLinkState() {
      var load = vs.__pkVariantLoad;
      var failed = load && load.state === 'error';
      var key = linkWaiting() ? (failed ? 'error' : 'loading') : '';
      if (linkNotice.getAttribute('data-state') === key) return;
      linkNotice.setAttribute('data-state', key); linkNotice.hidden = !key;
      linkNotice.textContent = !key ? '' : failed ? 'The sizes could not load. Your design is still here.' : 'Loading the sizes for your design…';
      if (key === 'error') {
        var retry = document.createElement('button'); retry.type = 'button'; retry.className = 'pkso-btn';
        retry.textContent = 'Load sizes again';
        retry.addEventListener('click', function () { if (load.retry) load.retry(); });
        linkNotice.appendChild(document.createTextNode(' ')); linkNotice.appendChild(retry);
      }
    }
    function fromLink() {
      if (!linkIntent || !statusDone) return;
      var s = st[linkIntent.shape], have = find(s, linkIntent.url);
      if (!have) {
        s.list.push({ u: linkIntent.url, j: '', pa: '', t: Date.now(), o: '', sv: '', sa: 0 });
        trim(s); have = s.list[s.list.length - 1];
      }
      if (!linkApplied) {
        s.idx = s.list.indexOf(have); s.state = 'ready'; s.ask = false; s.fit = false;
        linkCheck = true;
      }
      if (linkCanceled || linkApplied) return;
      var load = vs.__pkVariantLoad;
      if (!load || load.state !== 'ready') { showLinkState(); return; }
      linkApplying = true;
      if (!linkIntent.explicit) {
        var want = WORD[linkIntent.shape], hb = hiddenBtn(want);
        if (hb) hb.click();
        if (sizeShape() !== want) { linkApplying = false; showLinkState(); return; }
      }
      linkApplied = true; linkApplying = false;
      follow();
    }
    linkIntent = readLink();
    ui.addEventListener('click', function (e) {
      if (e.target.closest('[data-size]')) cancelLink();
    }, true);
    vs.addEventListener('paintly:variants-state', function () {
      fromLink(); showLinkState();
    });

    /* ---- start ---- */
    render();
    call('/api/shape/status?handle=' + encodeURIComponent(HANDLE), null, 8000).then(function (r) {
      if (typeof r.design === 'string' && r.design) design = r.design;
      if (r.enabled === false) enabled = false;
      restore();
      Object.keys(st).forEach(function (a) {
        var s = st[a], u = r.ready && r.ready[a];
        if (valid(u) && !find(s, u)) {
          s.list.unshift({ u: u, j: '', pa: '', t: 0, lib: true, o: '', sv: '', sa: 0 });
          /* the design's own picture is chosen when nothing of theirs is here, or when it was their choice; their
             own choice, or "none chosen", stays as it was (Codex re-review R2) */
          if ((!s.remembered && s.list.length === 1) || s.wantLib) s.idx = 0;
          else if (s.idx >= 0) s.idx++;
          trim(s);
          if (s.state === 'idle') s.state = 'ready';
        } else if (valid(u) && s.wantLib) s.idx = s.list.indexOf(find(s, u));
        s.wantLib = false;
      });
    }, function () {}).then(function () {
      statusDone = true;
      fromLink();
      follow();
      confirmSaved();
      /* a shape chosen before the service answered still gets its picture */
      var a = AI[cur], s = a && st[a];
      if (s && tapShape === null && Date.now() - tapAt < 15000 && tapAt && enabled && !s.list.length && s.state === 'idle') make(a, false);
    });
  }

  function boot() { document.querySelectorAll('.pkso[data-pkso]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
